import axiosSetup from "../utils/axiosSetup";

export const addProductSerialNumber = async (
  productId: any,
  serialNumber: any
) => {
  const response = await axiosSetup.post("/productSerialNumber/add", {
    productId,
    serialNumber,
  });
  return response?.data?.data;
};
export const getProductSerialNumberById = async (productIds: string[]) => {
  const response = await axiosSetup.post("/productSerialNumber/getById", {
    productIds,
  });
  return response?.data?.data;
};

export const getLastSerialNumber = async () => {
  const response = await axiosSetup.get("/trackSn/getLastSn");
  return response?.data?.data;
};

export const validateNonDispatchedSerialNumber = async (serialNumber: string) => {
  const response = await axiosSetup.post("/productSerialNumber/validateNonDispatchedSn", {
    serialNumber,
  });
  return response?.data?.data;   // { productId: string, productName?: string }
};
